import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { MockupSceneStyle } from '@/domain/mockups/mockupSceneTypes';

const initialState: MockupSceneStyle = {
  style: 'empty',
};

const editorSceneStyleSlice = createSlice({
  name: 'editorSceneStyle',
  initialState,
  reducers: {
    clear: state => {
      state.style = 'empty';
    },
    setStyle: (state, action: PayloadAction<{ style: string }>) => {
      state.style = action.payload.style;
    },
  },
});

export const { clear, setStyle } = editorSceneStyleSlice.actions;

export const editorSceneStyleReducer = editorSceneStyleSlice.reducer;
